import React from "react";
import {
  Alert,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Modal,
  ModalDialog,
  Stack,
  Typography,
} from "@mui/joy";
import { OrganizationIntegrationDisableImpact } from "../../common/types";

interface DisableImpactModalProps {
  open: boolean;
  integrationName?: string | null;
  impact?: OrganizationIntegrationDisableImpact | null;
  loading?: boolean;
  error?: string | null;
  saving?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DisableImpactModal: React.FC<DisableImpactModalProps> = ({
  open,
  integrationName,
  impact,
  loading = false,
  error = null,
  saving = false,
  onClose,
  onConfirm,
}) => (
  <Modal open={open} onClose={saving ? undefined : onClose}>
    <ModalDialog sx={{ width: "min(640px, calc(100vw - 32px))" }}>
      <DialogTitle>Disable {integrationName || "integration"}</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          {error && (
            <Alert color="danger" variant="soft">
              {error}
            </Alert>
          )}
          <Typography level="body-sm">
            Disabling {integrationName || "this integration"} will also disable
            the following skills:
          </Typography>
          {loading ? (
            <Typography level="body-sm" color="neutral">
              Loading blast radius...
            </Typography>
          ) : impact?.items?.length ? (
            <Stack component="ul" spacing={0.75} sx={{ pl: 2, m: 0 }}>
              {impact.items.map((item) => (
                <Typography
                  component="li"
                  key={`${item.offering_key}-${item.workspace_count}`}
                  level="body-sm"
                >
                  {item.display_name} ({item.workspace_count} workspace
                  {item.workspace_count === 1 ? "" : "s"})
                </Typography>
              ))}
            </Stack>
          ) : (
            <Typography level="body-sm" color="neutral">
              No dependent skills were reported for this integration.
            </Typography>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button color="danger" onClick={onConfirm} loading={saving}>
          Disable
        </Button>
        <Button
          variant="plain"
          color="neutral"
          onClick={onClose}
          disabled={saving}
        >
          Cancel
        </Button>
      </DialogActions>
    </ModalDialog>
  </Modal>
);

export default DisableImpactModal;
